import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CookiesBannerLink} from "../../../configuration/configuration.model";

@Component({
    selector: 'banner-link',
    templateUrl: './banner-link.component.html',
    styleUrls: ['./banner-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BannerLinkComponent {
	@Input() item: CookiesBannerLink;
}
